document.addEventListener("DOMContentLoaded", init());

function init() {
  detectVariantChange();
}

function detectVariantChange() {
  document.addEventListener('custom-variant-change', function(event) {
    const variantData = event.detail.variant;
    updateVariantContent(variantData);
  });
}

function updateVariantContent(variantData) {
  updateDaysOfWellness(variantData);
  updateProductImage(variantData);
}

function updateDaysOfWellness(variantData) {
  const daysOfWellnessItems = document.querySelectorAll(`[js-days-of-wellness="text"][data-variant-id="${variantData.id}"]`);

  if (!daysOfWellnessItems.length) {
    // Hide all the "Days of Wellness" wrappers?
    return;
  }

  // Only update image galleries that contain this variant
  daysOfWellnessItems.forEach((daysOfWellnessItem) => {
    [...daysOfWellnessItem.parentElement.querySelectorAll('[js-days-of-wellness="text"]')].forEach(sibling => sibling.style.display = sibling === daysOfWellnessItem ? "block" : "none");
  });

}

function updateProductImage(variantData) {
  const variantImages = document.querySelectorAll(`[js-product-gallery="variantImage"][data-variant-id="${variantData.id}"]`);

  if (!variantImages.length) {
    const productImage = document.querySelector('[js-product-gallery="productImage"]');
    if (productImage) productImage.style.display = "inline";
    return;
  }

  // Only update image galleries that contain this variant
  variantImages.forEach((image) => {
    [...image.parentElement.querySelectorAll('[js-product-gallery="variantImage"]')].forEach(sibling => sibling.style.display = sibling === image ? "inline" : "none");
  });
}




if (window.location.pathname.includes('/products/')) {
document.addEventListener("DOMContentLoaded", function(){

  function parseCurrencyToFloat(currencyString) {
    // Remove any non-numeric characters except . and ,
    const cleanedString = currencyString.replace(/[^\d.,]/g, '');
    const lastCommaIndex = cleanedString.lastIndexOf(',');
    const lastDotIndex = cleanedString.lastIndexOf('.');
    const decimalSeparator = lastCommaIndex > lastDotIndex ? ',' : '.';
    const normalizedString = cleanedString.replace(decimalSeparator === ',' ? /\./g : /,/g, '');
    const dotDecimalString = normalizedString.replace(decimalSeparator, '.');
    return parseFloat(dotDecimalString);
  }

  function ensurePrice(){
      requestAnimationFrame(function(){

        var qty = parseInt(document.getElementById('Quantity').value);
        if (!qty) qty = 1;

        if (document.getElementById('ProductPrice')) {
          var productPrice = parseFloat(document.getElementById('ProductPrice').getAttribute('content')) * 100;

          document.getElementById('ProductPrice').querySelector('.money').outerHTML = wetheme.formatMoney(productPrice * qty);
        }

        if (document.getElementById('ComparePrice')) {
          // If ComparePrice doesn't have a "content" attribute, set it to the number in the innerHTML
          if (!document.getElementById('ComparePrice_Shadow')) {
            document.getElementById('ComparePrice').insertAdjacentHTML('afterend', document.getElementById('ComparePrice').outerHTML.replace('ComparePrice', 'ComparePrice_Shadow'));
          }

          var comparePrice = parseCurrencyToFloat(document.getElementById('ComparePrice').innerHTML) * 100;
          document.getElementById('ComparePrice_Shadow').querySelector('.money').outerHTML = wetheme.formatMoney(comparePrice * qty);
          document.getElementById('ComparePrice').style.display = 'none';
        }

        ms_add_currency_code();
      });

  }

  var qty_btn = document.getElementById('Quantity');
  if (!qty_btn) return;

  // Get sibling .js-qty__adjust from qty_btn. Not a child
  var qtyAdjustButtons = document.querySelectorAll('.js-qty__adjust');
  qtyAdjustButtons.forEach(function(button) {
    button.addEventListener('click', ensurePrice);
  });

  qty_btn.addEventListener('change', ensurePrice);
  document.addEventListener('custom-variant-change', ensurePrice);

});
}

document.addEventListener("DOMContentLoaded", function(){
if (window.location.href.startsWith("https://manukasouth.com/pages/batch")) {
    var elementToHide = document.querySelector('.ms-section-announcement-bar-alt');
  elementToHide && (elementToHide.style.display = 'none');
}
});

// HOTFIX: Wiser recommendations triggered an avalanche of cart updates whenever the product qty changes
if (!window.location.href.includes('/cart')) {
  var cartDataInterval = setInterval(function() {
    if (typeof __wsAttrGetCartData === 'function') {
      clearInterval(cartDataInterval);
      console.log('Redefining __wsAttrGetCartData');
      __wsAttrGetCartData = function() {}
    }
  }, 100);
}

function ms_add_currency_code() {
  var currency_code = document.getElementById('_currency_code').innerHTML;
  var money_ele = document.getElementsByClassName('money');

  if (currency_code) {
      Array.from(money_ele).forEach(function(ele) {
        // CHeck if ele already has a currency-code child
        if (ele.querySelector('.currency-code')) return;
        ele.insertAdjacentHTML('beforeend', '<span class="currency-code"> ' + currency_code + ' </span>');
      });
  }
}
window.ms_add_currency_code = ms_add_currency_code;
if (window.location.href.includes('/products/')) {
  document.addEventListener("DOMContentLoaded", function(){
    ms_add_currency_code();
  });
}